


































import { defineComponent, PropType } from '@vue/composition-api'

export default defineComponent({
  props: {
    title: {
      type: String as PropType<string>,
      default: '',
    },
    required: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    requiredSelection: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    radioName: {
      type: String as PropType<string>,
      default: '',
    },
    useRadio: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  methods: {
    changeRadio(selected: string) {
      this.$emit('change-radio', selected)
    },
  },
})
